import * as React from 'react';
import { Image } from '@core-ds/icons/16';
import { TiptapButton } from '../TiptapButton';
import { Editor } from '@tiptap/react';

export const InsertImageButton = (props: { editor: Editor }) => {
   const editor: Editor = props.editor;

   return (
      <TiptapButton
         onClick={editor.commands.activateMediaManager}
         icon={<Image />}
         title={_js('Insert an image')}
      />
   );
};
